
export default function FeatureBox({ imageUrl, title, description })  {
  return (
    <div className="feature-box">
      <img src={imageUrl} alt="no image" />
      <div className="feature-desc">
        <h4 className="heading-4">{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
};

